import {
    createServiceAccount,
    deleteServiceAccount,
    fetchServiceAccounts,
    rotateServiceAccountSecret,
    setUserFlag,
    updateServiceAccount,
} from './service-accounts.utils';

const serviceAccounts = {
    namespaced: true,
    state: {
        error: {},
        serviceAccountList: [],
        createdServiceAccount: {},
    },
    mutations: {
        setServiceAccounts (state, { serviceAccounts }) {
            state.serviceAccountList = serviceAccounts;
        },
        setCreatedServiceAccount (state, { serviceAccount }) {
            state.createdServiceAccount = serviceAccount;
        },
        clearCreatedServiceAccount (state) {
            state.createdServiceAccount = {};
        },
        addToList (state, { serviceAccount }) {
            state.serviceAccountList.push(serviceAccount);
            state.createdServiceAccount = {};
        },
        removeFromList (state, { id }) {
            state.serviceAccountList = state.serviceAccountList.filter((sa) => sa.id !== id);
        },
        updateSecret (state, { id, clientId, clientSecret }) {
            const account = state.serviceAccountList.find((sa) => sa.id === id);
            if (account) {
                account.clientId = clientId;
                account.clientSecret = clientSecret;
            }
        },
        updateServiceAccount (state, { id, updates }) {
            state.serviceAccountList = state.serviceAccountList.map((sa) => {
                return sa.id === id ? { ...sa, ...updates } : sa;
            });
        },
        updateFlags (state, { id, flags }) {
            state.serviceAccountList = state.serviceAccountList.map((sa) => {
                return sa.id === id ? { ...sa, ...flags } : sa;
            });
        },
        setError (state, { error }) {
            state.error = error;
        },
    },
    actions: {
        async getServiceAccounts ({ commit }) {
            try {
                const { data } = await fetchServiceAccounts();
                commit('setServiceAccounts', { serviceAccounts: data });
            } catch (error) {
                commit('setError', { error });
                throw error;
            }
        },
        async createServiceAccount ({ commit }, serviceAccount) {
            try {
                const { data } = await createServiceAccount({ serviceAccount });
                commit('setCreatedServiceAccount', { serviceAccount: data });
            } catch (error) {
                commit('setError', { error });
                throw error;
            }
        },
        async deleteServiceAccount ({ commit }, { id }) {
            try {
                await deleteServiceAccount({ id });
                commit('removeFromList', { id });
            } catch (error) {
                commit('setError', { error });
                throw error;
            }
        },
        async updateServiceAccount ({ commit }, { id, updates }) {
            try {
                const { data } = await updateServiceAccount({ id, updates });
                commit('updateServiceAccount', { id, updates: data });

                return data;
            } catch (error) {
                commit('setError', { error });
                throw error;
            }
        },
        async setServiceAccountFlag ({ commit }, { id, flagName, value }) {
            try {
                await setUserFlag({ id, flagName, value });
                commit('updateFlags', { id, flags: { [flagName]: value } });
            } catch (error) {
                commit('setError', { error });
                throw error;
            }
        },
        async rotateServiceAccountSecret ({ commit }, { id }) {
            try {
                const { data } = await rotateServiceAccountSecret({ id });
                commit('updateSecret', {
                    id: data.id,
                    clientId: data.clientId,
                    clientSecret: data.clientSecret,
                });

                return data;
            } catch (error) {
                commit('setError', { error });
                throw error;
            }
        },
    },
    getters: {
        list: (state) => state.serviceAccountList,
        createdServiceAccount: (state) => state.createdServiceAccount,
    },
};

export default serviceAccounts;
